


































import Vue from 'vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalText from '@/components/common/control/CtrlNormalTxt.vue';
import { BUTTON } from '@/constants/label';
import { mapGetters } from 'vuex';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default Vue.extend({
  name: 'G_140_HaisoIrai_Renraku',
  components: {
    CtrlNormalBtn,
    CtrlNormalText,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    BUTTON,
    biko: '',
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  created() {
    this.biko = this.item.haisoIraiBiko;
  },
  methods: {
    // 自画面を閉じる
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    // キャンセル
    handleCancel() {
      this.hide(false);
    },
  },
});
